// import Vue from 'vue'
import moment from 'moment'
let dz = {
  /**
  * 生成随机字符串
  * @param len
  * @returns {string}
  */
  getRandomString: function (len) {
    let leng = len || 32
    var chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678'
    var maxPos = chars.length
    var pwd = ''
    for (var i = 0; i < leng; i++) {
      pwd += chars.charAt(Math.floor(Math.random() * maxPos))
    }
    return pwd
  },
  /**
  * 时间戳转 xxxx-xx-xx
  * @param value 时间戳
  * @returns {string}
  */
  timestampToshortText (value) {
    return moment(value * 1000).format('YYYY-MM-DD')
  },
  /**
  * 时间戳转 xxxx-xx-xx xx:xx(分)
  * @param value 时间戳
  * @returns {string}
  */
  timestampToMText (value) {
    return moment(value * 1000).format('YYYY-MM-DD HH:mm')
  },
  /**
  * 时间戳转 xxxx-xx-xx xx:xx:xx(秒)
  * @param value 时间戳
  * @returns {string}
  */
  timestampToLongText (value) {
    return moment(value * 1000).format('YYYY-MM-DD HH:mm:ss')
  },
  /**
   * 时间转时间戳 (秒)
   * 格式化时间戳
   * @param {number} time 时间
   */
  timeToTimestamp (time) {
    return moment(time, 'YYYY-MM-DD HH:mm:ss').valueOf() / 1000
  },
  /**
   * 获取当前时间戳 (秒)
   * 格式化时间戳
   * @param {number} time 时间
   */
  timeToTimestamps () {
    return moment(Date.now()).format('X')
  },
  /**
   * 获取当前年月日 (秒)
   * 格式化时间戳
   * @param {number} time 时间
   */
  timeToDatetimes () {
    return moment(Date.now()).format('YYYY-MM-DD')
  },
  /**
   * 时间转日期 xxxx:xx:xx
   * 格式化时间 2018-08-28
   * @param {string} time 时间
   */
  timeToDateTime (time) {
    let Timestamps = moment(time, 'YYYY-MM-DD HH:mm:ss').valueOf()
    return moment(Timestamps).format('YYYY-MM-DD')
  },
  /**
   * 时间转日期 xxxx:xx:xx
   * 格式化时间 2018-08-28 12:12
   * @param {string} time 时间
   */
  timeToDateTimes (time) {
    let Timestamps = moment(time, 'YYYY-MM-DD HH:mm:ss').valueOf()
    return moment(Timestamps).format('YYYY-MM-DD HH:mm')
  },
  // 循环
  foreach (arr, func) {
    for (var i in arr) {
      if (func(arr[i], i) === false) {
        return false
      }
    }
    return true
  },
  /**
   * 获取秒时间戳
   * @param  {Date}   day 标准时间格式
   * @return {Number}     转换成秒的时间戳
   */
  getSencondStamp (day) {
    return parseInt(moment(day)['_d'].getTime() / 1000)
  },
  /**
   * 时间戳/常见时间格式 格式化为 XXXX年XX月XX日
   * @param  {Date} day 标准时间格式/时间戳
   * @return {String}     2018年06月01日
   */
  timestampToYearText (day) {
    return moment(day).format('YYYY' + '年' + 'MM' + '月' + 'DD' + '日')
  },
  /**
   * 浅克隆
   * @param  {Object} obj   克隆对象
   * @return {Object} copy  克隆结果
   */
  clone (obj) {
    let copy = null
    // Handle the 3 simple types, and null or undefined
    if (obj == null || typeof obj !== 'object') return obj

    // Handle Date
    if (obj instanceof Date) {
      copy = new Date()
      copy.setTime(obj.getTime())
      return copy
    }

    // Handle Array
    if (obj instanceof Array) {
      copy = []
      for (var i = 0; i < obj.length; ++i) {
        copy[i] = this.clone(obj[i])
      }
      return copy
    }

    // Handle Object
    if (obj instanceof Object) {
      copy = {}
      if (window.JSON) {
        copy = JSON.parse(JSON.stringify(obj))
      } else {
        for (let j in obj) {
          copy = typeof obj[j] === 'object' ? this.clone(obj[j]) : obj[j]
        }
      }

      return copy
    }

    throw new Error("Unable to copy obj! Its type isn't supported.")
  },
  /**
   * 是否为微信浏览器
   * navigator.wxuserAgent 匹配win phone
   * @return {Boolean} true是 false
   */
  isWexinAgent () {
    let agent = navigator.userAgent.toLowerCase()

    return (/micromessenger/.test(agent)) || typeof navigator.wxuserAgent !== 'undefined'
  },
  /**
   * IOS字体大小设置为65%
   */
  adaptIOS () {
    let isIOS = null
    let u = navigator.userAgent
    if (/AppleWebKit.*Mobile/i.test(navigator.userAgent) || (/MIDP|SymbianOS|NOKIA|SAMSUNG|LG|NEC|TCL|Alcatel|BIRD|DBTEL|Dopod|PHILIPS|HAIER|LENOVO|MOT-|Nokia|SonyEricsson|SIE-|Amoi|ZTE/.test(navigator.userAgent))) {
      if (window.location.href.indexOf('?mobile') < 0) {
        try {
          if (/iPhone|mac|iPod|iPad/i.test(navigator.userAgent)) {
            isIOS = true
          } else {
            isIOS = false
          }
        } catch (e) {
          console.log(e)
        }
      }
    } else if (u.indexOf('iPad') > -1) {
      isIOS = true
    } else {
      isIOS = false
    }
    if (isIOS) {
      document.getElementsByTagName('html')[0].style.fontSize = '65%'
    }
  }
}

export default dz
